import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { Skeleton } from '@mint-lib/tw-components';
import { StaticDateSpan } from '@mint-lib/tw-components/patterns';

import { ScheduleTableType } from '../../../../types/queryScheduler.js';

const DateCell = ({ value, data }: ICellRendererParams<ScheduleTableType>) => {
  if (data?.__isSkeleton) {
    return <Skeleton />;
  }

  return <StaticDateSpan date={new Date(value + 'Z')} />;
};

export { DateCell };
